import { useEffect, useState } from 'react';
import { usePageContent } from '@/context/ContentContext';
import { telHref } from '@/lib/phone';

export default function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  const { phone } = usePageContent('contact');

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const heroHeight = window.innerHeight;
      setIsVisible(scrollY > heroHeight);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-background-200 shadow-lg shadow-black/10">
      <div className="w-full px-4 md:px-6 py-3 flex items-center justify-between gap-4 max-w-[1450px] mx-auto">
        <div className="hidden sm:flex items-center gap-3">
          <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-lg">
            <i className="ri-shopping-bag-line text-amber-600" />
          </div>
          <div>
            <div className="text-xs text-foreground-600">Specijalna ponuda</div>
            <div className="text-sm font-semibold text-foreground-950">Besplatna dostava preko 5.000 RSD</div>
          </div>
        </div>
        <div className="flex items-center gap-3 ml-auto">
          <div className="hidden md:flex items-center gap-2 text-xs text-foreground-600">
            <i className="ri-truck-line text-amber-600" />
            Dostava 2-4 dana
          </div>
          <a
            href="#products"
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-950 text-white font-label text-sm font-medium rounded-full hover:bg-foreground-900 transition-colors whitespace-nowrap"
          >
            Pogledaj proizvode
            <i className="ri-arrow-right-line" />
          </a>
          {phone && (
            <a
              href={telHref(phone)}
              className="inline-flex items-center gap-2 px-4 py-2.5 bg-amber-600 text-white font-label text-sm font-medium rounded-full hover:bg-amber-700 transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-fill" />
              <span className="hidden sm:inline">Pozovi</span>
            </a>
          )}
        </div>
      </div>
    </div>
  );
}